import React from 'react'
import Helmet from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { startsWith, isArray, truncate } from 'lodash'
import { removeLastSlash } from '../utils/misc'

const FB_APP_ID = process.env.REACT_APP_FB_APP_ID || '173531143357144'
const FB_DOMAIN_VERIFICATION = process.env.REACT_APP_FB_DOMAIN_VERIFICATION

interface Props {
  title: string
  description: string
  imageUrl?: string
  uri: string
  keywords?: string | string[]
  schemaJSON?: any
}

export const DOMAIN = process.env.PUBLIC_URL || 'http://localhost:3000'
const DEFAULT_IMAGE_URL = ''
const MAX_META_DESCRIPTION_LENGTH = 80

export default function Meta({
  title,
  description,
  imageUrl = DEFAULT_IMAGE_URL,
  uri,
  keywords = [],
  schemaJSON,
}: Props) {
  const { i18n } = useTranslation()
  const url = `${DOMAIN}${startsWith(uri, '/') ? '' : '/'}${removeLastSlash(uri)}`

  return (
    <Helmet>
      <html lang={i18n.language} />
      <title>{title}</title>
      <link rel="canonical" href={url} />
      <meta
        name="description"
        content={truncate(description, {
          length: MAX_META_DESCRIPTION_LENGTH,
        })}
      />
      <meta name="keywords" content={isArray(keywords) ? keywords.join(', ') : keywords} />
      <meta property="fb:app_id" content={FB_APP_ID} />
      <meta name="facebook-domain-verification" content={FB_DOMAIN_VERIFICATION} />
      <meta property="og:site_name" content="OnDemandChina" />
      <meta property="og:type" content="video.movie" />
      <meta property="og:title" content={title} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:url" content={url} />
      <meta property="og:description" content={description} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@ondemandchina" />
      <meta name="twitter:title" content={title} />
      {schemaJSON && (
        <script type="application/ld+json">
          {JSON.stringify(
            {
              ...schemaJSON,
              url,
              id: url,
            },
            null,
            2
          )}
        </script>
      )}
    </Helmet>
  )
}
